module.exports = __webpack_public_path__ + "static/media/img-logo-horizontal@3x.1ab23d7b.jpg";